import { Navigate, Outlet } from "react-router-dom"
import Sidebar from "@/components/Sidebar"
import { useUser } from "@/hooks/useUser"
import Header from "@/components/Header"
import { superAdminNavigations } from "@/constants"

export default function AdminLayout() {
  const { user, isPending } = useUser()
  const userRoles = user?.jenis_user || []
  const superAdmin = userRoles.includes("superadmin")

  if (!isPending && !superAdmin) return <Navigate to={"/"} />

  return (
    <main className="flex">
      <Sidebar navigationMenus={superAdminNavigations} />
      <section className="flex-1 overflow-x-auto p-5 min-h-screen">
        <Header />
        <Outlet />
      </section>
    </main>
  )
}
